import {InjectionToken} from "@angular/core";

export enum DashboardViewType {
  HOME_OWNER,
  AGENT
}

export const DASHBOARD_VIEW_TYPE = new InjectionToken<DashboardViewType>("DASHBOARD_VIEW_TYPE");
export const FELLO_CONNECT_BASE_URL = new InjectionToken<string>("FELLO_CONNECT_BASE_URL");
